var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.modelValue)?_c('div',[_c('NewConfirmPopup',{attrs:{"modelValue":_vm.modelValue,"error":"","okLabel":"Decline This Report","cancelLabel":"Cancel","title":"Are you sure you want to decline this report?","message":`The current RTWC report will no longer be valid.
The employee will be assigned a new task to submit an updated RTWC report.
You will need to review and verify the new report once it is provided.
This action cannot be undone.`},on:{"ok":function($event){return _vm.onOk()},"cancel":function($event){return _vm.onCancel()}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }